<script lang="ts" setup>
import Prose from '@/components/Prose.vue'

import type { PageElementOfType } from '../page-builder'

const props = defineProps<{
  element: PageElementOfType<'text'>
}>()

const p = document.createElement('p')
const dataIsOnlyWhitespace = computed(() => {
  p.innerHTML = props.element.data.text
  return p.textContent!.trim() === ''
})
</script>

<template>
  <Prose
    v-if="!dataIsOnlyWhitespace"
    class="max-w-none"
    :content="element.data.text"
    always-small
  />

  <Prose v-else class="italic opacity-70 max-w-none" content="Text eingeben" always-small />
</template>
